/**
 * Menus
 */

export default function HWY_Menus() {
	const selectors = {
		contentWrapper: ".hwy__menu",
		mobileSelector: ".selected-section-title",
		mobileList: ".available-titles",
		item: ".section-title",
	};

	this.init = () => {
		jQuery(selectors.mobileSelector).on("click", function () {
			jQuery(this).toggleClass("opened");
			jQuery(this).next().toggleClass("opened");
		});
		jQuery(selectors.item).on("click", function () {
			const target = jQuery(this).data("target");
			const title = jQuery(this).text();
			jQuery(this)
				.closest(selectors.contentWrapper)
				.find(".active")
				.removeClass("active");
			jQuery(this)
				.closest(selectors.contentWrapper)
				.find(`.section-title[data-target="${target}"`)
				.each(function () {
					jQuery(this).addClass("active");
				});
			jQuery(this)
				.closest(selectors.contentWrapper)
				.find(selectors.mobileSelector)
				.removeClass("opened");
			jQuery(this)
				.closest(selectors.contentWrapper)
				.find(selectors.mobileList)
				.removeClass("opened");
			jQuery(this)
				.closest(selectors.contentWrapper)
				.find(selectors.mobileSelector + " span")
				.text(title);

			jQuery(this)
				.closest(selectors.contentWrapper)
				.find(".section-content")
				.removeClass("active");
			jQuery(this)
				.closest(selectors.contentWrapper)
				.find(`.${target}`)
				.addClass("active");
		});
	};
}
